import React, { useEffect, useRef } from "react";
import { makeStyles, Text } from "@fluentui/react-components";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { NewformaCheckbox } from "../../../_base/Checkbox";

const useStyles = makeStyles({
    row: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },
    label: {
        fontSize: "12px",
    },
});

export interface AllowPartialDownloadSectionProps extends LocalizeContextProps {
    checked: boolean;
    disabled: boolean;
    isInactive: boolean;
    onChange: (_ev: any, data: any) => void;
}

const AllowPartialDownloadSection: React.FC<AllowPartialDownloadSectionProps> = (props) => {
    const styles = useStyles();
    const { checked, disabled, onChange, translate, isInactive } = props;

    const isChangedRef = useRef(false);

    useEffect(() => {
        if (isInactive) {
            isChangedRef.current = false;
            return;
        }
        if (isChangedRef.current) return;
        if (checked) return;

        onChange(null, { checked: true });
    }, [isInactive, checked, onChange]);

    const handleChange = (_ev: any, data: any) => {
        isChangedRef.current = true;
        onChange(_ev, data);
    };

    return (
        <div className={styles.row}>
            <NewformaCheckbox
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                dataTestId="allow-partial-checkbox"
            />
            <Text className={styles.label}>{translate("SHARED.MOREOPTIONS.CHECKBOX_RECIPIENTS") as string}</Text>
        </div>
    );
};

export default withLocalize(AllowPartialDownloadSection) as React.ComponentType<
    Omit<AllowPartialDownloadSectionProps, keyof LocalizeContextProps>
>;
